import ContactPageContainer from "./Contact.Container";

export default ContactPageContainer;